export default {"src":"/_next/static/media/instagram.16653731.ico","height":268,"width":284,"blurWidth":0,"blurHeight":0};